import { useEffect } from "react";
import { ToastBar, Toaster, toast } from "react-hot-toast";

import { CloseIcon } from "./ActionIcons";
import { IconButton } from "./IconButton";

const NO_EXCLUDED_MESSAGES: readonly string[] = [];

export function DismissibleToaster({
  excludedMessages = NO_EXCLUDED_MESSAGES,
}: {
  excludedMessages?: readonly string[];
}) {
  return (
    <Toaster position="top-right" toastOptions={{ duration: 5000 }}>
      {(notification) =>
        typeof notification.message === "string" &&
        excludedMessages.includes(notification.message) ? (
          <ExcludedToast id={notification.id} />
        ) : (
          <ToastBar toast={notification}>
            {({ icon, message }) => (
              <>
                {icon}
                {message}
                <IconButton
                  tone="quiet"
                  size="xs"
                  label="Dismiss notification"
                  tooltip="Dismiss this notification."
                  icon={<CloseIcon />}
                  containerClassName="ui-toast-dismiss"
                  onClick={() => toast.dismiss(notification.id)}
                />
              </>
            )}
          </ToastBar>
        )
      }
    </Toaster>
  );
}

/** Remove screen-owned messages, including those from late local handlers. */
function ExcludedToast({ id }: { id: string }) {
  useEffect(() => toast.remove(id), [id]);
  return null;
}
